var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCustomer = function SvgLogoBrandCustomer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "kundenlogo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 40,
    viewBox: "0 0 120 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1057",
    "data-name": "Rechteck 1057",
    width: 120,
    height: 40,
    fill: "#ddd",
    opacity: 0.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_maskieren_33",
    "data-name": "Gruppe maskieren 33",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WVV-Logo-rot-rgb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10289",
    d: "M43.9,0,33.1,25.2l-.7,1.7h-.1L30.9,0H22.3L10.6,26.9h-.1l-.1-2L9.6,0H0L2.5,40h9.1L23,13.5h.1L24.6,40h9.2L51.6,0Z",
    fill: "#d3003e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10290",
    d: "M75.4,0,61.6,28.6,59.1,0H56.7L50.6,13.8,53.4,40H63.5L83.3,0Z",
    fill: "#d3003e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10291",
    d: "M107.7,0,93.8,28.6,91.3,0H89L82.7,12.6,85.6,40H95.7L115.5,0Z",
    fill: "#d3003e"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCustomer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-customer.e00293052ae5d79cf142beb03ef8593a.svg";